import script from "./EventTimelineComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./EventTimelineComponent.vue?vue&type=script&setup=true&lang=js"

import "./EventTimelineComponent.vue?vue&type=style&index=0&id=6bddcb56&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bddcb56"]])

export default __exports__